<section>
    <button class="minus" (click)="decreaseQuantity()" [disabled]="true"><xm-media-image [imageOptions]="minusImage" center="auto" size="auto"></xm-media-image></button>
    <span class="quantity">{{ quantity }}</span>
    <button class="plus" (click)="increaseQuantity()" [disabled]="true"><xm-media-image [imageOptions]="plusImage" center="auto" size="auto"></xm-media-image></button>
</section>
